import { useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";

const DeleteAccount = ({ setIsShowPromptReAuthFor }) => {
  const [isShowPrompt, setIsShowPrompt] = useState(false);

  return (
    <>
      {isShowPrompt && (
        <>
          <div className="fixed top-[30%] md:left-[35%] left-[5%] right-[5%] md:w-[450px] max-w-[90vw] min-h-[100px] px-5 py-4 z-40 bg-dark-lighten rounded-md shadow-md">
            <div className="mx-auto mb-7 h-16 w-16 rounded-full shadow-md shadow-gray-darken bg-gradient-to-t from-transparent to-gray-darken flex items-center justify-center">
              <AiOutlineDelete size={40} className="text-primary " />
            </div>
            <p className="text-white text-lg">
              Do you really want to delete this account ?
            </p>
            <div className="flex mt-8 gap-5 justify-end">
              <button
                onClick={() => {
                  setIsShowPromptReAuthFor("delete");
                  setIsShowPrompt(false);
                }}
                className="px-4 py-2 rounded-full bg-dark-lighten-2 text-white hover:bg-white hover:text-dark-darken transition duration-300"
              >
                Yes
              </button>
              <button
                onClick={() => setIsShowPrompt(false)}
                className="px-4 py-2 rounded-full text-white bg-dark-lighten-2 hover:bg-primary  transition duration-300"
              >
                Cancel
              </button>
            </div>
          </div>
          <div
            onClick={() => setIsShowPrompt(false)}
            className="fixed top-0 left-0 w-full h-full z-[5] bg-black/60"
          ></div>
        </>
      )}
      <div className="flex justify-center mt-12 mb-6">
        <button
          onClick={() => setIsShowPrompt(true)}
          className="px-5 py-2  border rounded-full text-primary border-dark-lighten-2 bg-dark-lighten hover:bg-primary hover:text-white transition duration-300"
        >
          Delete account
        </button>
      </div>
    </>
  );
};

export default DeleteAccount;
